export default __webpack_public_path__ + "static/media/sacrificialheart.e59edfbb.png";